



import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';

@Component({
  name: 'no-filter',
  components: {},
})
export default class NoFilter extends Vue {}
